function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.577 506.461c-7.065-7.868-173.004-194.146-173.004-321.035C70.574 83.182 153.756 0 256.001 0s185.426 83.182 185.426 185.426c0 126.888-165.939 313.167-173.004 321.035-6.637 7.393-18.224 7.378-24.846 0z",
    style: {},
    fill: "#ff5752",
    "data-original": "#ff5752",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.426 185.426C441.426 83.182 358.244 0 256.001 0v512c4.552 0 9.106-1.843 12.423-5.539 7.063-7.867 173.002-194.146 173.002-321.035z",
    style: {},
    fill: "#db3a3c",
    "data-original": "#db3a3c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 278.719c-51.442 0-93.291-41.851-93.291-93.293s41.851-93.293 93.291-93.293 93.291 41.851 93.291 93.293-41.851 93.293-93.291 93.293z",
    style: {},
    fill: "#efefef",
    "data-original": "#efefef",
    className: "hovered-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 92.134v186.585c51.442 0 93.291-41.851 93.291-93.293s-41.851-93.292-93.291-93.292z",
    style: {},
    fill: "#c5d8df",
    "data-original": "#c5d8df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.7b93f8d3168254475c32e20a9f5ba590.svg";
export { ForwardRef as ReactComponent };